import apiClient, { extractData } from "./client";

export async function getPayrolls(params = {}) {
  const response = await apiClient.get("/payroll", { params });
  return extractData(response);
}

export async function getMyPayslips(params = {}) {
  const response = await apiClient.get("/payroll/my", { params });
  return extractData(response);
}

export async function fetchPayslipLogo() {
  try {
    const response = await apiClient.get("/payroll/payslip-logo", {
      responseType: "blob",
    });
    const blob = response.data;
    if (!blob || !String(blob.type || "").startsWith("image/")) return null;
    return blob;
  } catch (error) {
    if (error?.response?.status === 404) return null;
    throw error;
  }
}

export async function uploadPayslipLogo(file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await apiClient.put("/payroll/payslip-logo", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return extractData(response);
}

export async function deletePayslipLogo() {
  const response = await apiClient.delete("/payroll/payslip-logo");
  return extractData(response);
}

export async function generatePayroll(data) {
  const response = await apiClient.post("/payroll/generate", data);
  return extractData(response);
}

export async function approvePayroll(id, data = {}) {
  const response = await apiClient.patch(`/payroll/${id}/approve`, data);
  return extractData(response);
}
